import { useCallback, useState } from 'react';
import { makeProvider } from 'react-provider-maker';
import { useApi } from '../api-provider';
import { useAuth } from '../auth-provider';

export const { Provider: UnaffiliatedProvider, useProvider: useUnaffiliatedAuth } =
  makeProvider(() => {
    const [api] = useApi();
    const { loadCredentials } = useAuth();
    const [state, setState] = useState<{
      loading?: boolean | undefined;
      isSignedUp?: boolean;
      isEmailTokenValidated?: boolean;
      emailToken?: string;
      phoneCodeToken?: string;
      phone?: string;
      phoneCode?: string;
      phoneCodeDesc?: string;
      phoneCountry?: string;
      sendAttempts?: number;
      error?:
        | 'INVALID_PHONE_CODE'
        | 'USER_NOT_SIGNED_UP'
        | 'USER_NOT_ALLOWED'
        | 'AUTHORIZATION_NOT_ALLOWED';
      lastCodeChangeDate?: string;
    }>({});
    const currentEmailToken = state.emailToken;

   

    

    const sendPhoneCode = useCallback(
      async (token?: string) => {
        const sendPhoneCodeResult = await api.callService(
          'require-auth-sms-code',
          {
            action: 'LEGAL_REPRESENTATIVE_SIGN_UP',
          },
          { signedUrlToken: token }
        );

        if (sendPhoneCodeResult.data.info.reason === 'USER_NOT_ALLOWED') {
          setState((currentState) => ({
            ...currentState,
            lastCodeChangeDate:
              sendPhoneCodeResult.data.info.lastCodeChangeDate,
            error: sendPhoneCodeResult.data.info.reason,
          }));
        }

        if (
          sendPhoneCodeResult.data.info.reason === 'AUTHORIZATION_NOT_ALLOWED'
        ) {
          setState((currentState) => ({
            ...currentState,
            error: sendPhoneCodeResult.data.info.reason,
          }));
        }

        setState((currentState) => ({
          ...currentState,
          sendAttempts: sendPhoneCodeResult.data.info.sendAttempts,
        }));

        return sendPhoneCodeResult.data;
      },
      [api]
    );

    const validateEmailToken = useCallback(
      async (token: string) => {
        setState({ loading: true });

        const signUpResult = await api
          .callService('validate-email-token', {}, { signedUrlToken: token })
          .catch(() => {});

        if (signUpResult && signUpResult.eventName === 'EmailTokenValidated') {
          const maskedPhone = '*'.repeat(8) + signUpResult.data.user.phone.phone.slice(-2);
          setState({
            isSignedUp: true,
            emailToken: token,
            isEmailTokenValidated: true,
            phone: maskedPhone
          });
          await sendPhoneCode(token);
        } else
          setState((currentState) => ({
            ...currentState,
            loading: false,
            isEmailTokenValidated: false,
          }));
      },
      [api,sendPhoneCode]
    );

    const validatePhoneCode = useCallback(
      async (code: string) => {
        setState((currentState) => ({ ...currentState, loading: true }));
        var validatePhoneCodeResult;

        try {
          validatePhoneCodeResult = await api.callService(
            'validate-phone-code',
            {
              code,
              action: 'LEGAL_REPRESENTATIVE_SIGN_UP',
            },
            { signedUrlToken: currentEmailToken }
          );
        } catch (e) {
          setState((currentState) => ({
            ...currentState,
            error: 'AUTHORIZATION_NOT_ALLOWED',
          }));
        }

        if (validatePhoneCodeResult?.eventName === 'PhoneCodeValidated') {
          const phoneCodeToken = validatePhoneCodeResult.data.token;
          const obtainCredentialsResult = await api.callService(
            'obtain-credentials',
            {},
            { phoneCodeToken }
          );
          const jwt = obtainCredentialsResult.sensitiveData.credentials.jwt;
          await loadCredentials(jwt);
          setState({
            loading: false,
          });
        }

        if (validatePhoneCodeResult?.eventName === 'PhoneCodeNotValidated') {
          setState((currentState) => ({
            ...currentState,
            loading: false,
            error: 'INVALID_PHONE_CODE',
          }));
        }

        setState((currentState) => ({ ...currentState, loading: false }));
      },
      [api, loadCredentials, currentEmailToken]
    );

    return {
      ...state,
      validateEmailToken,
      validatePhoneCode,
      sendPhoneCode,
      api,
    };
  });
